import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { ManagerData, ManagerOutcome, Outcome, Relevance } from 'pbts/c1/api/analysis/v1/analysis'
import { InsightType } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export type GrantsManagerLabelProps = {
    manager: ManagerData
}

export const GrantsManagerLabel: FC<GrantsManagerLabelProps> = ({ manager }) => {
    if (!manager.relevance) {
        return null
    }
    if (!manager.managerId || !manager.displayName) {
        return null
    }
    return (
        <Typography>
            <FormattedMessage
                id="analysis_insights_grants_manager"
                defaultMessage="{group_with_access} out of {num_in_group} users who report to {manager} have this entitlement"
                values={{
                    group_with_access: manager.relevance.groupWithAccess,
                    num_in_group: manager.relevance.numInGroup,
                    manager: manager.displayName,
                }}
            />
        </Typography>
    )
}

export type GrantsManagerProps = {
    outcome: Outcome | undefined
    insightType: InsightType
    showIcon?: boolean
}

export const GrantsManager: FC<GrantsManagerProps> = ({ outcome, insightType, showIcon = true }) => {
    if (!outcome?.outcome) {
        return null
    }
    const managerOutcome = outcome.outcome as unknown as ManagerOutcome
    if (!managerOutcome.managers.length) {
        return null
    }
    // Grab the most relevant manager.
    const manager = managerOutcome.managers
        .filter(({ relevance }: ManagerData): Relevance | undefined => relevance)
        .sort((a: ManagerData, b: ManagerData): number => {
            if (!a.relevance || !b.relevance) {
                return 0
            }
            if (a.relevance.groupWithAccess === b.relevance.groupWithAccess) {
                if (a.relevance.numInGroup > b.relevance.numInGroup) {
                    return -1
                }
                return 1
            }
            if (a.relevance.groupWithAccess > b.relevance.groupWithAccess) {
                return -1
            }
            return 1
        })
        .shift()
    if (!manager) {
        return null
    }
    if (!manager.relevance) {
        return null
    }
    if (!manager.managerId || !manager.displayName) {
        return null
    }
    if (!showIcon) {
        return <GrantsManagerLabel manager={manager} />
    }
    return (
        <InsightItem key="grants_account_item" insightType={insightType}>
            <GrantsManagerLabel manager={manager} />
        </InsightItem>
    )
}
